import TravelExploreOutlinedIcon from "@mui/icons-material/TravelExploreOutlined";
import QueryBuilderOutlinedIcon from "@mui/icons-material/QueryBuilderOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";

export const metaData = [
  {
    name: "Easy to Search govahan Taxi!",
    image: <TravelExploreOutlinedIcon className="!w-10 !h-10" />,
  },
  {
    name: "Quick Pickups To Save Time!",
    image: <QueryBuilderOutlinedIcon className="!w-10 !h-10" />,
  },
  {
    name: "Inclusive Rates To Enjoy Ride!",
    image: <PaymentsOutlinedIcon className="!w-10 !h-10" />,
  },
];
